import {
  Nav,
  Hero,
  EpisodesSection,
  SocialsSection,
  CheckerDivider,
} from "../components";
import Footer from "../components/Footer";

export function Home() {
  return (
    <div className="min-h-screen bg-cream">
      <Nav />
      <Hero />
      <EpisodesSection />
      <SocialsSection />
      <CheckerDivider />
      <Footer />
    </div>
  );
}
